import { useState } from "react";
import { UserIcon, LockClosedIcon, EyeIcon, EyeSlashIcon, GlobeAltIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

const LoginForm = ({ doLogin }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    function handleLogin() {
        doLogin(username, password);
    }
    
    function handleKeyup(e) {
        if (e.keyCode === 13) handleLogin();
    };

    return (
        <div
            id="authentication-modal"
            tabIndex="-1"
            aria-hidden="true"
            className="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full h-screen bg-gray-50"
        >
            <div className="relative w-full max-w-[480px] h-full sm:h-auto sm:min-h-[650px] flex flex-col bg-white sm:shadow-2xl sm:rounded-2xl overflow-hidden border border-gray-100">
                {/* Header Area */}
                <div className="bg-[#f4f4f4] pt-14 pb-8 px-8 flex flex-col items-center">
                    <h3 className="text-4xl font-bold text-[#525252] text-center mb-2">
                        Netsoft Office
                    </h3>
                </div>

                {/* Form Area */}
                <div className="p-8 pb-10 flex-1 flex flex-col bg-white">
                    <div className="space-y-6 flex-1">
                        <div>
                            <label
                                htmlFor="username"
                                className="text-left block mb-2 text-sm font-semibold text-gray-700"
                            >
                                Your username
                            </label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none">
                                    <UserIcon className="w-5 h-5 text-gray-500" />
                                </div>
                                <input
                                    type="text"
                                    name="username"
                                    id="username"
                                    className="bg-[#fafafa] border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full pl-10 p-3 outline-none transition-all hover:bg-white"
                                    placeholder="username"
                                    required
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </div>
                        </div>
                        
                        <div>
                            <label
                                htmlFor="password"
                                className="text-left block mb-2 text-sm font-semibold text-gray-700"
                            >
                                Your password
                            </label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none">
                                    <LockClosedIcon className="w-5 h-5 text-gray-500" />
                                </div>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    id="password"
                                    placeholder="••••••••"
                                    className="bg-[#fafafa] border border-gray-200 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full pl-10 pr-10 p-3 outline-none transition-all hover:bg-white tracking-[0.2em] font-medium"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    onKeyUp={handleKeyup}
                                />
                                <button 
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute inset-y-0 right-0 flex items-center pr-3.5 text-gray-500 hover:text-gray-800 transition-colors"
                                >
                                    {showPassword ? (
                                        <EyeIcon className="w-5 h-5" />
                                    ) : (
                                        <EyeSlashIcon className="w-5 h-5" />
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className="pt-2">
                            <button
                                onClick={handleLogin}
                                className="w-full text-white bg-[#f97316] hover:bg-[#ea580c] focus:ring-4 focus:outline-none focus:ring-orange-200 font-bold rounded-lg text-sm px-5 py-3.5 text-center transition-colors shadow-sm tracking-wide"
                            >
                                LOGIN
                            </button>
                        </div>
                    </div>
                    

                </div>
            </div>
        </div>
    );
}

export default LoginForm;
